export default __webpack_public_path__ + "static/media/ear_nose_throat.6d6d9631.png";